var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 128,
    viewBox: "0 0 127 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.889 0H14.1111C6.35 0 0 6.4 0 14.2222V113.778C0 121.6 6.35 128 14.1111 128H112.889C120.65 128 127 121.6 127 113.778V14.2222C127 6.4 120.65 0 112.889 0ZM112.889 56.8889H70.5556V14.2222H112.889V56.8889ZM56.4444 14.2222V56.8889H14.1111V14.2222H56.4444ZM14.1111 71.1111H56.4444V113.778H14.1111V71.1111ZM70.5556 113.778V71.1111H112.889V113.778H70.5556Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.e76a95962a2842a6e22cd83433288a89.svg";
export { ForwardRef as ReactComponent };